import constants from "../../core/constants";
import moment from "moment";
import DialogTemplate from "./dialog/dialog.html";
import DialogController from "./dialog/dialog.controller";

class Controller {
  constructor($injector, $stateParams, $mdDialog, Sections, GoogleMaps) {
    "ngInject";
    this.$mdDialog = $mdDialog;
    this.$injector = $injector;
    this.$stateParams = $stateParams;
    this.sections = Sections.settingsSections;
    this.Events = $injector.get("Events");
    this.privateBusRequest = $injector.get("PrivateBusRequests");
    this.User = $injector.get("User");
    this.Captain = $injector.get("Captain");
    this.showNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
    this.googleMapsUrl = GoogleMaps.getSource();

    this.waypoints = {};
    this.positions = [];
  }
  $onInit() {
    this.privateBusRequest
      .get(this.$stateParams.id)
      .$promise.then((response) => {
        this.privateBusReq = response;
        this.status = response.status;
        if (this.privateBusReq.stops) {
          this.stops = this.privateBusReq.stops;
          this.waypoints = [
            {
              location: {
                lat: Number(this.stops[0].lat),
                lng: Number(this.stops[0].lng),
              },
              stopover: true,
            },
            {
              location: {
                lat: Number(this.stops[1].lat),
                lng: Number(this.stops[1].lng),
              },
              stopover: true,
            },
          ];

          this.positions = [
            [Number(this.stops[0].lat), Number(this.stops[0].lng)],
            [Number(this.stops[1].lat), Number(this.stops[1].lng)],
          ];
        }
        if (this.privateBusReq.user) {
          this.User.get(this.privateBusReq.user).$promise.then((response) => {
            this.customer = response;
          });
        }
        if (this.privateBusReq.operator_decision_meta) {
          this.operatorMeta = this.privateBusReq.operator_decision_meta;
          this.operatorMeta.date = moment(this.operatorMeta.date).format(
            constants.timeFormat
          );
          this.User.get(this.operatorMeta.operator).$promise.then(
            (response) => {
              this.operator = response;
            }
          );
        }
        if (this.privateBusReq.outbound_trip_date) {
          this.privateBusReq.outbound_trip_date = moment(
            this.privateBusReq.outbound_trip_date
          ).format(constants.dateTimeFormat);
        }

        if (this.privateBusReq.inbound_trip_date) {
          this.privateBusReq.inbound_trip_date = moment(
            this.privateBusReq.inbound_trip_date
          ).format(constants.dateTimeFormat);
        }
        if (this.privateBusReq.price) {
          this.privateBusReq.price /= constants.currencyBy;
        }
        if (this.privateBusReq.captain) {
          this.Captain.get(this.privateBusReq.captain).$promise.then(
            (response) => {
              this.captain = response;
            }
          );
        }
      });
  }
  openDialog() {
    const addCaptin = this.$mdDialog.show({
      controllerAs: "$ctrl",
      controller: DialogController,
      template: DialogTemplate,
      autoWrap: false,
      bindToController: true,
    });
    addCaptin.then((obj) => {
      const options = {
        captain_id: obj,
      };
      this.privateBusRequest
        .addCaptin(this.$stateParams.id, options)
        .$promise.then(
          (response) => {
            this.status = response.status;
            this.Captain.get(response.captain).$promise.then((response) => {
              this.captain = response;
            });
            this.operatorMeta = response.operator_decision_meta;
            this.operatorMeta.date = moment(this.operatorMeta.date).format(
              constants.timeFormat
            );
            this.User.get(this.operatorMeta.operator).$promise.then(
              (response) => {
                this.operator = response;
              }
            );
            this.Events.emit(this.showNotificationEvent, {
              message: "Request Accepted Successffully",
            });
          },
          (response) =>
            this.Events.emit(this.errorNotificationEvent, response.data)
        );
    });
  }
  rejectRequest() {
    this.privateBusRequest.reject(this.$stateParams.id).$promise.then(
      (response) => {
        this.status = response.status;
        this.operatorMeta = response.operator_decision_meta;
        this.operatorMeta.date = moment(this.operatorMeta.date).format(
          constants.timeFormat
        );
        this.User.get(this.operatorMeta.operator).$promise.then((response) => {
          this.operator = response;
        });
        this.Events.emit(this.showNotificationEvent, {
          message: "Request rejected succesfully",
        });
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );
  }
}
export default Controller;



// WEBPACK FOOTER //
// ./src/pages/privateBusRequest/privateBusRequest.controller.js